export class IndentQuantityRequestDto{
    saleOrderId: number;
    itemId: number;
    constructor(saleOrderId: number,
    itemId: number){
        this.saleOrderId=saleOrderId
        this.itemId=itemId;
    }
    }